import { rem } from '@heathmont/moon-utils';
import useRouter from '~/client/hooks/router/useRouter';
import Translate from '~/client/shared/i18n/Translate';
import NextLink from '~/client/shared/NextLink';
import Stack from '~/client/shared/Stack';
import type TableOfContent from './@types/tableOfContent';
import Header from './styles/Header';
import Item from './styles/Item';
import List from './styles/List';

type Props = {
  tableOfContents: TableOfContent[];
  toggleShowModal?: () => void;
};

const TableOfContents: FC<Props> = ({ tableOfContents, toggleShowModal }) => {
  const { asPath } = useRouter();
  return (
    <Stack marginBottom={rem(40)}>
      <Header color="trunks.100" as="p">
        <Translate id="blog.tableOfContents" />
      </Header>
      <List>
        {tableOfContents &&
          tableOfContents.map((tableOfContentItem) => (
            <Item
              isSubItem={tableOfContentItem.type === 'h3'}
              key={tableOfContentItem.href}
              onClick={toggleShowModal}
            >
              <NextLink href={`${asPath}#${tableOfContentItem.href}`}>
                {tableOfContentItem.value}
              </NextLink>
            </Item>
          ))}
      </List>
    </Stack>
  );
};

export default TableOfContents;
